import { render, staticRenderFns } from "./WarningsTpl.vue?vue&type=template&id=6b86b89f&scoped=true&"
import script from "./WarningsTpl.vue?vue&type=script&lang=js&"
export * from "./WarningsTpl.vue?vue&type=script&lang=js&"
import style0 from "./WarningsTpl.vue?vue&type=style&index=0&id=6b86b89f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b86b89f",
  null
  
)

export default component.exports